import React from "react";
import ContentLoader from "react-content-loader";
import createMemo from "@src/static/hooks/createMemo";
import {getCookie} from '@utils/common'
const renderLoadComponent = (props: any) => {
    return props.loading === false ? (
        <React.Fragment>{props.children}</React.Fragment>
    ) : (
        <ContentLoader
            height={700}
            width={400}
            speed={1}
            primaryColor={getCookie('zwzt_night') === '1' ? '#2B2A34' : '#f3f3f3'}
            secondaryColor={getCookie('zwzt_night') === '1' ? '#2B2A34' : '#ecebeb'}
        >
            {/* <rect x="20" y="20" rx="5" ry="5" width="360" height="120" />
            <rect x="20" y="150" rx="5" ry="5" width="360" height="120" />
            <rect x="20" y="280" rx="5" ry="5" width="173" height="240" />
            <rect x="205" y="280" rx="5" ry="5" width="173" height="240" />
            <rect x="20" y="530" rx="5" ry="5" width="173" height="240" />
            <rect x="205" y="530" rx="5" ry="5" width="173" height="240" /> */}

        </ContentLoader>
    );
};

export default createMemo(renderLoadComponent);
